import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
} from "@mui/material";
import {
  LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer,
  CartesianGrid, Legend, BarChart, Bar, AreaChart, Area, PieChart,
  Pie, Cell, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis,
  Radar, ComposedChart, ScatterChart, Scatter, ZAxis
} from "recharts";

function SP_Analytics({
  data,
  XAxisKey = "X Axis",
  YAxis1 = "Y Axis",
  YAxis2 = "",
  YAxis3 = "",
  charts = ["line", "bar", "area", "pie", "radar", "composed", "scatter"], // default = all charts
}) {
  const COLORS = ["#1976d2", "#2e7d32", "#f57c00", "#d32f2f"];

  return (

<>
<div>
  {/* Line Chart */}
      {charts.includes("line") && (
        <Grid item xs={12}>
          <Card sx={{ borderRadius: 3, boxShadow: 3 }}>
            <CardContent>
              <Typography variant="subtitle1" gutterBottom>
                🎢 Line Chart
              </Typography>
              <ResponsiveContainer width="100%" height={300}>
                <LineChart data={data}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey={XAxisKey} />
                  <YAxis />
                  <Tooltip />
                  <Legend />
                  <Line type="monotone" dataKey={YAxis1} stroke="#1976d2" strokeWidth={2} />
                  {YAxis2 && <Line type="monotone" dataKey={YAxis2} stroke="#2e7d32" strokeWidth={2} />}
                  {YAxis3 && <Line type="monotone" dataKey={YAxis3} stroke="#f57c00" strokeWidth={2} />}
                </LineChart>
              </ResponsiveContainer>
            </CardContent>
          </Card>
        </Grid>
      )}
</div>


<div>
{/* Bar Chart */}
      {charts.includes("bar") && (
        <Grid item xs={12}>
          <Card sx={{ borderRadius: 3, boxShadow: 3 }}>
            <CardContent>
              <Typography variant="subtitle1" gutterBottom>
                📊 Bar Chart
              </Typography>
              <ResponsiveContainer width="100%" height={300}>
                <BarChart data={data}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey={XAxisKey} />
                  <YAxis />
                  <Tooltip />
                  <Legend />
                  <Bar dataKey={YAxis1} fill="#1976d2" />
                  {YAxis2 && <Bar dataKey={YAxis2} fill="#2e7d32" />}
                  {YAxis3 && <Bar dataKey={YAxis3} fill="#f57c00" />}
                </BarChart>
              </ResponsiveContainer>
            </CardContent>
          </Card>
        </Grid>
      )}
</div>



<div>
   {/* Area Chart */}
      {charts.includes("area") && (
        <Grid item xs={12}>
          <Card sx={{ borderRadius: 3, boxShadow: 3 }}>
            <CardContent>
              <Typography variant="subtitle1" gutterBottom>
                📉 Area Chart
              </Typography>
              <ResponsiveContainer width="100%" height={300}>
                <AreaChart data={data}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey={XAxisKey} />
                  <YAxis />
                  <Tooltip />
                  <Legend />
                  <Area type="monotone" dataKey={YAxis1} stackId="1" stroke="#1976d2" fill="#1976d2" />
                  {YAxis2 && <Area type="monotone" dataKey={YAxis2} stackId="1" stroke="#2e7d32" fill="#2e7d32" />}
                  {YAxis3 && <Area type="monotone" dataKey={YAxis3} stackId="1" stroke="#f57c00" fill="#f57c00" />}
                </AreaChart>
              </ResponsiveContainer>
            </CardContent>
          </Card>
        </Grid>
      )}
</div>

<div>
   {/* Pie Chart (only makes sense for one Y-axis, so use YAxis1 by default) */}
      {charts.includes("pie") && (
        <Grid item xs={12}>
          <Card sx={{ borderRadius: 3, boxShadow: 3 }}>
            <CardContent>
              <Typography variant="subtitle1" gutterBottom>
               💹 Pie Chart ({YAxis1} Distribution)
              </Typography>
              <ResponsiveContainer width="100%" height={300}>
                <PieChart>
                  <Tooltip />
                  <Legend />
                  <Pie
                    data={data}
                    dataKey={YAxis1}
                    nameKey={XAxisKey}
                    outerRadius={120}
                    label
                  >
                    {data.map((_, index) => (
                      <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                    ))}
                  </Pie>
                </PieChart>
              </ResponsiveContainer>
            </CardContent>
          </Card>
        </Grid>
      )}
</div>


<div>
    {/* Radar Chart */}
      {charts.includes("radar") && (
        <Grid item xs={12}>
          <Card sx={{ borderRadius: 3, boxShadow: 3 }}>
            <CardContent>
              <Typography variant="subtitle1" gutterBottom>
               🎢 Radar Chart
              </Typography>
              <ResponsiveContainer width="100%" height={300}>
                <RadarChart data={data}>
                  <PolarGrid />
                  <PolarAngleAxis dataKey={XAxisKey} />
                  <PolarRadiusAxis />
                  <Radar name={YAxis1} dataKey={YAxis1} stroke="#1976d2" fill="#1976d2" fillOpacity={0.6} />
                  {YAxis2 && (
                    <Radar name={YAxis2} dataKey={YAxis2} stroke="#2e7d32" fill="#2e7d32" fillOpacity={0.6} />
                  )}
                  {YAxis3 && (
                    <Radar name={YAxis3} dataKey={YAxis3} stroke="#f57c00" fill="#f57c00" fillOpacity={0.6} />
                  )}
                  <Legend />
                </RadarChart>
              </ResponsiveContainer>
            </CardContent>
          </Card>
        </Grid>
      )}
</div>

<div>
    {/* Composed Chart */}
      {charts.includes("composed") && (
        <Grid item xs={12}>
          <Card sx={{ borderRadius: 3, boxShadow: 3 }}>
            <CardContent>
              <Typography variant="subtitle1" gutterBottom>
               📶 Composed Chart
              </Typography>
              <ResponsiveContainer width="100%" height={300}>
                <ComposedChart data={data}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey={XAxisKey} />
                  <YAxis />
                  <Tooltip />
                  <Legend />
                  <Bar dataKey={YAxis1} barSize={20} fill="#1976d2" />
                  {YAxis2 && <Area type="monotone" dataKey={YAxis2} fill="#2e7d32" stroke="#2e7d32" />}
                  {YAxis3 && <Line type="monotone" dataKey={YAxis3} stroke="#f57c00" />}
                </ComposedChart>
              </ResponsiveContainer>
            </CardContent>
          </Card>
        </Grid>
      )}
</div>

<div>
   {/* Scatter Chart */}
      {charts.includes("scatter") && (
        <Grid item xs={12}>
          <Card sx={{ borderRadius: 3, boxShadow: 3 }}>
            <CardContent>
              <Typography variant="subtitle1" gutterBottom>
                📈 Scatter Chart ({YAxis1}{YAxis2 && ` vs ${YAxis2}`}{YAxis3 && ` vs ${YAxis3}`})
              </Typography>
              <ResponsiveContainer width="100%" height={300}>
                <ScatterChart>
                  <CartesianGrid />
                  <XAxis dataKey={YAxis1} name={YAxis1} />
                  {YAxis2 && <YAxis dataKey={YAxis2} name={YAxis2} />}
                  {YAxis3 && <ZAxis dataKey={YAxis3} name={YAxis3} range={[60, 400]} />}
                  <Tooltip cursor={{ strokeDasharray: "3 3" }} />
                  <Legend />
                  <Scatter name="Data" data={data} fill="#1976d2" />
                </ScatterChart>
              </ResponsiveContainer>
            </CardContent>
          </Card>
        </Grid>
      )}
</div>
  
    </>
  );
}

export default SP_Analytics;
